import { useState, useEffect } from 'react'
import React from 'react';
import classNames from 'classnames'

interface PagersProps {
    pageCount: number
    currentPage: number
    pagerClass: {
        default: string
        inactive: string
        active: string
        disabled: string
    }
    onChange: (pageNumber: number) => void
}

const Pagers = (props: PagersProps) => {
    const { pageCount, currentPage, pagerClass, onChange } = props

    const [pagers, setPagers] = useState<(number | string)[]>([])

    const pagerDisplay = (total: number, current: number) => {
        const PAGER_COUNT = 7
        const PAGER_DISPLAY_COUNT = 5
        const PAGER_ITEM_SYMBOL_FIRST = 1
        const PAGER_ITEM_SYMBOL_LAST = total
        const PAGER_ITEM_SYMBOL_LEFT = 'left'
        const PAGER_ITEM_SYMBOL_RIGHT = 'right'

        const totalPage = total
        const pageNumber = current

        const halfPagerDisplayCount = Math.floor(PAGER_DISPLAY_COUNT / 2)
        const pagerDisplayCount =
            totalPage > PAGER_COUNT ? PAGER_DISPLAY_COUNT : totalPage

        let startPageNumber = 1
        let endPageNumber = totalPage

        if (totalPage > PAGER_COUNT) {
            if (pageNumber > halfPagerDisplayCount) {
                startPageNumber = Math.min(
                    pageNumber - halfPagerDisplayCount,
                    totalPage - pagerDisplayCount + 1
                )
                endPageNumber = Math.min(
                    startPageNumber + pagerDisplayCount - 1,
                    totalPage
                )
            } else {
                endPageNumber = pagerDisplayCount
            }
        }

        const pagerList = []

        if (totalPage > PAGER_COUNT) {
            pagerList.push(PAGER_ITEM_SYMBOL_FIRST)
            if (startPageNumber > 1) {
                pagerList.push(PAGER_ITEM_SYMBOL_LEFT)
            }
        }

        for (let i = startPageNumber; i <= endPageNumber; i++) {
            pagerList.push(i)
        }

        if (totalPage > PAGER_COUNT) {
            if (endPageNumber < totalPage) {
                pagerList.push(PAGER_ITEM_SYMBOL_RIGHT)
            }
            pagerList.push(PAGER_ITEM_SYMBOL_LAST)
        }

        return pagerList
    }

    useEffect(() => {
        const pagerList = pagerDisplay(pageCount, currentPage)
        setPagers(pagerList)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageCount, currentPage])

    const onPaginate = (pageNumber: number) => {
        onChange(pageNumber)
    }

    const renderPager = (pager: number | string, index: number) => {
        if (typeof pager === 'number') {
            const className = classNames(
                pagerClass.default,
                pager === currentPage
                    ? pagerClass.active
                    : pagerClass.inactive
            )
            return (
                <button
                    key={index}
                    className={className}
                    onClick={() => onPaginate(pager)}
                >
                    {pager}
                </button>
            )
        }

        if (pager === 'left' || pager === 'right') {
            const className = classNames(
                pagerClass.default,
                pagerClass.inactive
            )
            return (
                <button
                    key={index}
                    className={className}
                    onClick={() =>
                        onPaginate(
                            pager === 'left'
                                ? currentPage - 5
                                : currentPage + 5
                        )
                    }
                >
                    ...
                </button>
            )
        }

        return null
    }

    return <>{pagers.map((pager, index) => renderPager(pager, index))}</>
}

export default Pagers 